// Max number of files a user can attach when submitting/sharing a take-home
// assignment (the share flow and the interview-experience flow). Grading upload
// is separate and not governed by this.
export const MAX_TAKEHOME_SUBMISSION_FILES = 1;

// File extensions accepted for take-home submission uploads. Mirrors the
// backend allow-list in apps/takehomes/controller.go (allowedTakehomeExtensions).
export const ACCEPTED_EXTENSIONS = new Set([
  '.pdf', '.txt', '.md', '.doc', '.docx', '.ipynb', '.zip', '.xlsx',
]);
